export const findInObject = (list, field, value) => {
  return list != null && typeof list === 'object'
    ? Object.values(list).find(item => item[field] === value)
    : null
}
